import React from 'react';
import { string, func, array, object, oneOf } from 'prop-types';
import classnames from 'classnames/bind';
import { renderLinks } from '../../common';

import Illustration from 'foundations/Illustrations/Illustration';

import styles from './HotspotA.css';
import textStyles from '../../common.css';

const cx = classnames.bind(styles);

const HotspotA = ({ title, description, listItems, withIllustration, link, onClick, colorScheme }) => {
  const links = [
    {
      colorScheme,
      onClick,
      class: cx('link', { 'v3': !description && !listItems }),
      text: link,
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      size: 'l',
      minWidth: 1367
    },
    {
      colorScheme,
      onClick,
      class: cx('link', { 'v3': !description && !listItems }),
      text: link,
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      size: 'm',
      minWidth: 321,
      maxWidth: 1366
    },
    {
      colorScheme,
      onClick,
      class: cx('link', { 'v3': !description && !listItems }),
      text: link,
      icon: { direction: 'right', name: 'link-arrow-right-17', type: 'other' },
      size: 's',
      maxWidth: 320
    }
  ];
  
  try {
    if (description && listItems) {
      throw Error ('HotspotA is composed by either description or listItems, not both.');
    }
  }

  catch (err) {
    console.warn(err);
    return null;
  }

  return (
    <div className={classnames(colorScheme, styles.wrapper)}>
      <div className={styles.container}>
        <h1 className={classnames(textStyles.title, cx('title', { 'v3': !description && !listItems }))}>
          {title}
        </h1>
        {
          description && 
            <p className={classnames(textStyles.description, styles.description)}>{description}</p>
        }
        {
          listItems && 
            <ul className={styles.descriptionItems}>
              {listItems.map((item, i) => 
                <li className={textStyles.description} key={`desc-item-${i}`}>{item}</li>)}
            </ul>
        }
        
        {renderLinks(links)}

        <Illustration
          name={withIllustration.name}
          size={withIllustration.size}
          customClasses={styles.illustration}
        />
      </div>
    </div>
  );
};

HotspotA.propTypes = {
  title: string.isRequired,
  description: string,
  listItems: array,
  withIllustration: object,
  link: string.isRequired,
  onClick: func,
  colorScheme: oneOf([
    'lb01',
    'lb02',
    'lb03',
    'lb04',
    'lb05',
    'lb06',
    'lb07',
    'lb08',
    'db01',
    'db02',
    'db03',
    'db04',
  ])
};

HotspotA.defaultProps = {
  colorScheme: 'lb01'
};

HotspotA.displayName = 'HotspotA';

export default HotspotA;



// WEBPACK FOOTER //
// ./src/uis/components/Hotspots/Landing/HotspotA/HotspotA.js